import { useRef, useCallback } from 'react'

import { useFormContext, get } from 'react-hook-form'

export const useDateAutoCopy = (
  sourcePath: string,
  destinationPath: string
) => {
  const { getValues, setValue, control } = useFormContext()

  const latestSourceValueRef = useRef(undefined)

  // The default value of the field might be reset when lazy loading completes,
  // so we need to be careful we don't get fooled into thinking that's a change by the user.
  const currentDefaultValueRef = useRef(undefined)
  const currentDefaultValue = get(control.defaultValuesRef.current, sourcePath)

  if (currentDefaultValueRef.current !== currentDefaultValue) {
    currentDefaultValueRef.current = currentDefaultValue

    // the form has been reset, so we need to update what we think the current value is
    latestSourceValueRef.current = currentDefaultValue
  }

  const handleFocus = useCallback(() => {
    if (!control.defaultValuesRef.current) {
      return
    }

    const currentSourceValue = getValues(sourcePath)
    const currentDestinationValue = getValues(destinationPath)

    // Only copy if Source value has changed or if Destination value is blank
    if (
      currentSourceValue != latestSourceValueRef.current ||
      !currentDestinationValue
    ) {
      setValue(destinationPath, currentSourceValue)
      latestSourceValueRef.current = currentSourceValue
    }
  }, [
    sourcePath,
    destinationPath,
    control.defaultValuesRef,
    getValues,
    setValue
  ])

  return {
    onFocus: handleFocus
  }
}
